import { getApplicationResourceManager } from '@neos/app'
import { createEnumType } from '@neos/core'

/**
 * Specifies the CustomViewFilterComponent.
 */
export enum CustomViewFilterComponent {
  /** Default */
  default = 'Default',
  /** Calendar day */
  calendarDay = 'CalendarDay',
  /** Month */
  calendarMonth = 'CalendarMonth',
  /** Year */
  calendarYear = 'CalendarYear'
}

export const customViewFilterComponentEnumType = createEnumType('CustomViewFilterComponent', {
  default: { name: 'Default', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewFilterComponent.Default') ?? this.name }, getEnabled() { return true } },
  calendarDay: { name: 'CalendarDay', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewFilterComponent.CalendarDay') ?? this.name }, getEnabled() { return true } },
  calendarMonth: { name: 'CalendarMonth', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewFilterComponent.CalendarMonth') ?? this.name }, getEnabled() { return true } },
  calendarYear: { name: 'CalendarYear', get caption() { return getApplicationResourceManager('LicenseManagement').find('enums.CustomViewFilterComponent.CalendarYear') ?? this.name }, getEnabled() { return true } },
})
